var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntakeAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4651 0H3.53488C1.58262 0 0 1.58262 0 3.53488V12.4651C0 14.4174 1.58262 16 3.53488 16H12.4651C14.4174 16 16 14.4174 16 12.4651V3.53488C16 1.58262 14.4174 0 12.4651 0Z",
    fill: "#3B6CAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 11.7207C7.80268 11.7207 7.61339 11.6423 7.47383 11.5027C7.33426 11.3631 7.25586 11.1739 7.25586 10.9765V5.02299C7.25586 4.82562 7.33426 4.63634 7.47383 4.49678C7.61339 4.35721 7.80268 4.27881 8.00005 4.27881C8.19742 4.27881 8.3867 4.35721 8.52626 4.49678C8.66583 4.63634 8.74423 4.82562 8.74423 5.02299V10.9765C8.74423 11.1739 8.66583 11.3631 8.52626 11.5027C8.3867 11.6423 8.19742 11.7207 8.00005 11.7207Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02348 8.74399C4.82611 8.74399 4.63683 8.66558 4.49726 8.52602C4.3577 8.38646 4.2793 8.19717 4.2793 7.9998C4.2793 7.80243 4.3577 7.61314 4.49726 7.47358C4.63683 7.33402 4.82611 7.25562 5.02348 7.25562H10.977C11.1743 7.25562 11.3636 7.33402 11.5032 7.47358C11.6428 7.61314 11.7212 7.80243 11.7212 7.9998C11.7212 8.19717 11.6428 8.38646 11.5032 8.52602C11.3636 8.66558 11.1743 8.74399 10.977 8.74399H5.02348Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntakeAddIcon);
export default __webpack_public_path__ + "static/media/intake-add-icon.e6e6af3af0836194e05b4ac0c888fe4e.svg";
export { ForwardRef as ReactComponent };